import { memo, useCallback, useState } from 'react';
import { FormSpy } from 'react-final-form';
import cn from 'classnames';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';

import styles from './ErknmActDocument.module.scss';
import { ErknmFieldMark } from '../../MainModule/components/ErknmFieldMark';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { KnmLateFieldsRemark } from '../../../KnmPackage/KnmLateFieldsRemarkModule/components/KnmLateFieldsRemark';

interface IErknmActDocumentProps {
  attachmentsNumber: number;
  formRef: IKnmFormRef | undefined;
  index: number;
  isWatchOnly: boolean;
  lateFieldName: string | undefined;
  name: string;
  id: string;
}

export const ErknmActDocument = memo(
  ({ attachmentsNumber, formRef, index, isWatchOnly, lateFieldName, name, id }: IErknmActDocumentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.ActDocument}>
        <div className="shared-group-label">
          Файл акта
          <ErknmFieldMark fieldName={name} />
          {lateFieldName && <KnmLateFieldsRemark lateFieldPath={lateFieldName} fieldId={id} />}
          <span className="shared-no-wrap-text">
            <Button
              className={cn('shared-btn-add', styles.ActDocumentAddButton)}
              text="Добавить"
              variant="link"
              color="primary"
              type="button"
              id="fileAddButton"
              disabled={isWatchOnly || attachmentsNumber > 0}
              onClick={openSignModal}
            />
          </span>
        </div>

        <KnmAttachmentsSigning
          isWatchOnly={isWatchOnly}
          name={name}
          isVisibleSignModal={isVisibleSignModal}
          closeSignModal={closeSignModal}
          formRef={formRef}
        />
        <FormSpy subscription={{ errors: true, touched: true }}>
          {props => {
            const fieldError = props.errors?.acts?.[index]?.document;
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;
            const isFieldTouched = props.touched?.places;

            if (isFieldTouched && errorMessage) {
              return <p className="shared-input-error shared-row__small-margin">{errorMessage}</p>;
            }

            return null;
          }}
        </FormSpy>
      </div>
    );
  },
);
